module.exports = __webpack_public_path__ + "img/one_2.eb6b0cd1.png";